import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Återanvändbar SEO-komponent för per-sida meta-taggar.
 *
 * Användning:
 *   <SEO
 *     title="Bygg kalkyl program | Operio"
 *     description="..."
 *     canonical="/bygg-kalkyl-program"
 *     jsonLd={{...}}
 *   />
 */
const SEO = ({
  title,
  description,
  canonical,
  keywords,
  ogImage = 'https://operio.nu/operio-og-image.png',
  jsonLd,
  noindex = false,
}) => {
  const fullCanonical = canonical
    ? (canonical.startsWith('http') ? canonical : `https://operio.nu${canonical}`)
    : undefined;

  return (
    <Helmet prioritizeSeoTags>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {fullCanonical && <link rel="canonical" href={fullCanonical} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {fullCanonical && <meta property="og:url" content={fullCanonical} />}
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="sv_SE" />
      <meta property="og:site_name" content="Operio" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />

      {/* JSON-LD structured data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
